// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__6AkqH","forgotPass":"LoginForm_forgotPass__K7jDt","recaptcha":"LoginForm_recaptcha__AY2vJ"};